function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 16.5h3.75v-6.25h5.5v6.25h3.75V6.75L8 1.875 1.5 6.75v9.75zM0 18V6l8-6 8 6v12H9.25v-6.25h-2.5V18H0z",
  fill: "currentColor"
});
var SvgHomeSvg = function SvgHomeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    fill: "none"
  }, props), _ref);
};
export default SvgHomeSvg;